export const PLANNER_DEFAULT_PAGE = ""
export const PLANNER_PAGES = {
  "": "Overview",
}

export const PLANNERS_DEFAULT_PAGE = ""
export const PLANNERS_PAGES = {
  "": "Planner",
}

export const pages = (
  location: string
): { section: string; name: string; pages: Record<string, string>; defaultPage: string } => {
  const page = location.split("/").pop()
  let sectionPages: Record<string, string> = PLANNERS_PAGES
  let defaultPage = PLANNERS_DEFAULT_PAGE

  let section = page ?? defaultPage
  let name = sectionPages[section]
  if (!name) {
    section = defaultPage
    name = sectionPages[defaultPage]
  }
  return { section, name, pages: sectionPages, defaultPage }
}
